import { render, staticRenderFns } from "./GDefaultTemplate.vue?vue&type=template&id=bb1f3820&scoped=true&"
import script from "./GDefaultTemplate.vue?vue&type=script&lang=ts&"
export * from "./GDefaultTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./GDefaultTemplate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GDefaultTemplate.vue?vue&type=style&index=1&id=bb1f3820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1f3820",
  null
  
)

export default component.exports